import {
  MAX_UPLOAD_FILE_ROWS,
  MAX_UPLOAD_FILE_SIZE_MB,
} from "constants/constants";

export const UPLOAD_FIELD_IDS = {
  ACTION: "upload-action",
};

export const UPLOAD_QUERY_PARAMS = {
  SCRIPT_ID: "scriptId",
};

export const UPLOAD_ICONS = {
  CLOUD_UPLOAD: "cloudUpload",
  INFO: "info",
  INSERT_DRIVE_FILE: "insertDriveFile",
};

export const UPLOAD_FILE_ACCEPT = ".csv";

export const UPLOAD_COPY = {
  PAGE_SUBTITLE: "Upload your file and track processing history.",
  ACTION_LABEL: "Action",
  ACTION_PLACEHOLDER: "Select Action",
  ACTION_HINT: "Choose the operation you want to perform.",
  SUPPORTED_FORMAT_LABEL: "Supported Format",
  SUPPORTED_FORMAT_VALUE: "CSV Only (.csv)",
  MAX_ROWS_LABEL: "Max No. of Rows",
  HEADER_ROW_LABEL: "Header Row",
  HEADER_ROW_VALUE: "Mandatory",
  UPLOAD_BUTTON: "Upload File",
  SUCCESS_MESSAGE: "File uploaded successfully!",
  FAILED_MESSAGE: "Upload failed. Please try again.",
  UPLOAD_ERROR_FALLBACK: "Upload failed",
  DROP_TITLE: "Drag & Drop CSV file here or",
  BROWSE_BUTTON: "Browse Files",
  FILE_HINT: `CSV only (.csv) • Max no. of rows: ${MAX_UPLOAD_FILE_ROWS}`,
  FILE_SIZE_ERROR: `File size must be ${MAX_UPLOAD_FILE_SIZE_MB} MB or less.`,
};

export const UPLOAD_INFO_ITEMS = [
  {
    id: "format",
    label: UPLOAD_COPY.SUPPORTED_FORMAT_LABEL,
    value: UPLOAD_COPY.SUPPORTED_FORMAT_VALUE,
  },
  {
    id: "maxRows",
    label: UPLOAD_COPY.MAX_ROWS_LABEL,
    value: String(MAX_UPLOAD_FILE_ROWS),
  },
  {
    id: "headerRow",
    label: UPLOAD_COPY.HEADER_ROW_LABEL,
    value: UPLOAD_COPY.HEADER_ROW_VALUE,
  },
];

export const UPLOAD_HISTORY_SEARCHABLE_FIELDS = ["name", "status.name"];

export const UPLOAD_HISTORY_FIELD_LABELS = {
  name: "file name",
  "status.name": "status",
};

export const UPLOAD_HISTORY_STATUS_VARIANT = {
  PROCESSED: "processed",
  PARTIAL: "partial",
  UPLOADED: "uploaded",
  PENDING: "pending",
  FAILED: "failed",
};

export const UPLOAD_HISTORY_STATUS_FILTER = {
  PROCESSED: "processed",
  FAILED: "failed",
  UPLOADED: "uploaded",
};

export const UPLOAD_HISTORY_COPY = {
  TITLE: "Recent Uploads",
  LOGIN_REQUIRED: "Unable to load upload history. Please log in again.",
  LOAD_ERROR_FALLBACK: "Failed to load upload history.",
  EMPTY_STATE:
    "No uploads match your filters. Try changing search, status, or date range.",
  DOWNLOAD_SUCCESS: "Processed file downloaded successfully!",
  DOWNLOAD_ERROR_FALLBACK: "Error fetching processed file",
  STATUS_FAILED: "Failed",
  STATUS_PARTIAL: "Partial Success",
  STATUS_PENDING: "Pending",
  STATUS_COMPLETED: "Completed",
  STATUS_ALL_FAILED: "All rows failed to process",
  ROWS_FAILED: (count) => `${count} row(s) could not be processed`,
  COLUMN_FILE_NAME: "File Name",
  COLUMN_UPLOADED_ON: "Uploaded On",
  COLUMN_TOTAL_ROWS: "Total Rows",
  COLUMN_ERROR_ROWS: "Error Rows",
  COLUMN_STATUS: "Status",
  COLUMN_ACTION: "Action",
  DOWNLOAD_BUTTON: "Download",
  DOWNLOAD_LOADING: "Loading...",
  DOWNLOAD_UNAVAILABLE: "Not Available",
  PAGINATION_PREVIOUS: "Previous",
  PAGINATION_NEXT: "Next",
  PAGINATION_SHOWING: (start, end, total) =>
    `Showing ${start} to ${end} of ${total} uploads`,
  PAGE_SIZE_SUFFIX: (size) => `${size} / page`,
  DATE_FALLBACK: "-",
  EMPTY_CELL: "-",
};
